// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as SterlingIcons$LiveRoom from "../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";

function noFlag(imgStyle) {
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey40_nohashtag)),
                          tl: {
                            hd: Css.borderRadius(Css.px(20)),
                            tl: /* [] */0
                          }
                        }),
                    tl: {
                      hd: imgStyle,
                      tl: /* [] */0
                    }
                  })
            });
}

function getCurrencyFlag(flagCode, imgStyle) {
  if (flagCode === "AED") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Ae48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "ARS") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Ar48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "AUD") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Au48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "BRL") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Br48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "BTC") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Btc48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "CAD") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Ca48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "CHF") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Ch48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "CNY") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Cn48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "ETH") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Eth48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "EUR") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Eu48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "GBP") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Gb48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "HKD") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Hk48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "IDR") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Id48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "INR") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.In48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "JPY") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Jp48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "KRW") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Kr48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "MXN") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Mx48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "PHP") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Ph48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "QAR") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Qa48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "RUB") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Ru48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "SAR") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Sa48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "SGD") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Sg48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "TWD") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Tw48Rounded.make, {
                className: imgStyle
              });
  } else if (flagCode === "USD") {
    return React.createElement(SterlingIcons$LiveRoom.Flags.Us48Rounded.make, {
                className: imgStyle
              });
  } else {
    return noFlag(imgStyle);
  }
}

function RoundCurrencyFlag(props) {
  return getCurrencyFlag(props.flagCode, Curry._1(Css.merge, {
                  hd: Curry._1(Css.style, {
                        hd: Css.width(Css.px(32)),
                        tl: {
                          hd: Css.height(Css.px(32)),
                          tl: /* [] */0
                        }
                      }),
                  tl: {
                    hd: Curry._1(Css.style, Belt_Option.getWithDefault(props.styles, /* [] */0)),
                    tl: /* [] */0
                  }
                }));
}

var make = RoundCurrencyFlag;

export {
  noFlag ,
  getCurrencyFlag ,
  make ,
}
/* Css Not a pure module */
